import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { InputBaseComponent } from '../../base';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-autocomplete' },
  selector: 'pulse-autocomplete',
  templateUrl: './autocomplete.component.html',
})
export class AutocompleteComponent
  extends InputBaseComponent
  implements OnInit
{
  @Input() autocomplete = 'off';
  @Input() label = null;
  @Input() max = null;
  @Input() override maxLength = 999999999;
  @Input() min = null;
  @Input() minLength = 0;
  @Input() pattern = null;
  @Input() placeholder = '';
  @Input() ellipsis = false;
  @Input() readonly = false;
  @Input() required = null;
  @Input() type: any;
  @Input() testIdLabel: string;
  @Input() testIdButtonClear: string;
  @Input() withEye = false;

  @Output() optionSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  /**
   *  Saves item selected.
   */
  valueSelected: string;

  /**
   * Input property flag isHtml.
   */
  @Input() isHTML = false;

  /**
   * Input property options for autocomplete.
   */
  @Input()
  get options(): any {
    return this.lastOptions;
  }
  set options(value: any) {
    if (this.lastOptions !== value) {
      this.lastOptions = value;
    }
  }

  protected lastOptions = ['One', 'Two', 'Three'];

  constructor(public override el: ElementRef) {
    super(el);
  }

  ngOnInit(): void {}

  /**
   * Method to emit event with current value selected.
   *
   * @param event MatAutocompleteSelectedEvent.
   */
  selected(event: MatAutocompleteSelectedEvent): void {
    this.valueSelected = event.option.value;
    this.optionSelected.next(event.option.value);
    Promise.resolve(null).then(() => {
      this.nativeElement.value =
        event.option.value.companyServiceName || event.option.value;
      this.pulseChange.emit({ value: event.option.value });
    });
  }

  get nativeElement() {
    return this.inputNative.nativeElement;
  }

  onBlurInput(event: any) {
    this.blur.emit(event);
  }
}
